var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#E8E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83398 15.3362V16.0417C6.83398 16.6053 7.05787 17.1458 7.45638 17.5443C7.8549 17.9428 8.3954 18.1667 8.95898 18.1667H16.0423C16.6059 18.1667 17.1464 17.9428 17.5449 17.5443C17.9434 17.1458 18.1673 16.6053 18.1673 16.0417V15.3333M12.5007 14.9792V7.1875M12.5007 7.1875L14.9798 9.66667M12.5007 7.1875L10.0215 9.66667",
    stroke: "#2A6ED4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a9712ce56b3f01c6d3ca206a09e313ca.svg";
export { ForwardRef as ReactComponent };